module.exports = __webpack_public_path__ + "static/Darliene-Tenorio-0699e2ecb9286b872a1c4b944ff74458.jpg";